module.exports = __webpack_public_path__ + "static/media/score_back.540ab683.jpg";